export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.4-1406.10",
  commitId: "d86f10292959fab765fbb16ff77f0275c2a63c75",
  commitTime: "2026-09-04T14:06:10.000Z",
});
